import { createDealRequest } from "src/repositories/deal.repository";

import {
    fetchActions,
    fetchOperatorActions,
    createOperatorActionRequest,
    operatorActivate,
    getOperatorDebtSimulation as getOperatorDebtSimulationRequest,
    finish,
    inactive
} from "src/repositories/debt.repository";

import {
    getOperators as getOperatorsRequest,
    list,
    text as sendText,
    finishRequest as sendFinishRequest,
    loadRequest,
    upload
} from "src/repositories/operator.repository";

import {
    operatorList,
    createPhone as createPhoneRequest,
    updatePhone as updatePhoneRequest,
    createEmail as createEmailRequest,
    updateEmail as updateEmailRequest,
    hygienizeDebtor as hygienizeDebtorRequest
} from "src/repositories/debtor.repository";

import { AUTH_SET_TOKEN } from "modules/auth/actions/authentication.action";
import {
    LOAD_REQUESTS_ERROR,
    LOAD_REQUESTS_REQUEST,
    LOAD_REQUESTS_SUCCESS,
    LOAD_REQUEST_ERROR,
    LOAD_REQUEST_REQUEST,
    LOAD_REQUEST_SUCCESS
} from "modules/requests/actions/request.actions";

/**
 * Action Types
 */
export const CONTACT_UPDATED = "CONTACT_UPDATED";

export const DIALER_CALL_UPDATED = "DIALER_CALL_UPDATED";
export const DIALER_CALL_ENDED = "DIALER_CALL_ENDED";

export const DEAL_CREATE_LOADING = "DEAL_CREATE_LOADING";
export const DEAL_CREATED = "DEAL_CREATED";

export const DEBT_ACTIONS_LOADING = "DEBT_ACTIONS_LOADING";
export const DEBT_ACTIONS_LOADED = "DEBT_ACTIONS_LOADED";
export const DEBT_ACTIONS_CLEAR = "DEBT_ACTIONS_CLEAR";

export const OPERATOR_ACTION_CREATED = "OPERATOR_ACTION_CREATED";

export const CALL_FINISHED = "CALL_FINISHED";

export const OPERATOR_LOAD_DEBTORS_REQUEST = "OPERATOR_LOAD_DEBTORS_REQUEST";
export const OPERATOR_LOAD_DEBTORS_SUCCESS = "OPERATOR_LOAD_DEBTORS_SUCCESS";
export const OPERATOR_LOAD_DEBTORS_ERROR = "OPERATOR_LOAD_DEBTORS_ERROR";

export const OPERATOR_LOAD_DEBT_SIMULATION_REQUEST =
    "OPERATOR_LOAD_DEBT_SIMULATION_REQUEST";
export const OPERATOR_LOAD_DEBT_SIMULATION_SUCCESS =
    "OPERATOR_LOAD_DEBT_SIMULATION_SUCCESS";
export const OPERATOR_LOAD_DEBT_SIMULATION_ERROR =
    "OPERATOR_LOAD_DEBT_SIMULATION_ERROR";

export const OPERATORS_LOAD_REQUEST = "OPERATORS_LOAD_REQUEST";
export const OPERATORS_LOAD_SUCCESS = "OPERATORS_LOAD_SUCCESS";
export const OPERATORS_LOAD_ERROR = "OPERATOR_LOAD_ERROR";

export const OPERATOR_PHONE_CREATED = "OPERATOR_PHONE_CREATED";
export const OPERATOR_PHONE_UPDATED = "OPERATOR_PHONE_UPDATED";

export const OPERATOR_EMAIL_CREATED = "OPERATOR_EMAIL_CREATED";
export const OPERATOR_EMAIL_UPDATED = "OPERATOR_EMAIL_UPDATED";

export const OPERATOR_HYGIENIZED_DEBTOR = "OPERATOR_HYGIENIZED_DEBTOR";

export const OPERATOR_DIAL_TIMER_CHANGED = "OPERATOR_DIAL_TIMER_CHANGED";

export const ACTIVATE_DEBT_REQUEST = "ACTIVATE_DEBT_REQUEST";
export const ACTIVATE_DEBT_SUCCESS = "ACTIVATE_DEBT_SUCCESS";
export const ACTIVATE_DEBT_ERROR = "ACTIVATE_DEBT_ERROR";

export const SEND_TEXT_REQUEST = "SEND_TEXT_REQUEST";
export const SEND_TEXT_SUCCESS = "SEND_TEXT_SUCCESS";
export const SEND_TEXT_ERROR = "SEND_TEXT_ERROR";

export const SET_VOIP_CAMPAIGN = "SET_VOIP_CAMPAIGN";

/**
 * Action Creators
 */
export const updateContact = contact => ({
    type: CONTACT_UPDATED,
    payload: contact
});

export const updateDialerCall = call => ({
    type: DIALER_CALL_UPDATED,
    payload: call
});

export const callEnded = () => ({
    type: DIALER_CALL_ENDED
});

export const dealCreateLoading = isLoading => ({
    type: DEAL_CREATE_LOADING,
    payload: isLoading
});

export const dealCreated = deal => ({
    type: DEAL_CREATED,
    payload: deal
});

export const debtActionsLoading = isLoading => ({
    type: DEBT_ACTIONS_LOADING,
    payload: isLoading
});

export const debtActionsLoaded = result => ({
    type: DEBT_ACTIONS_LOADED,
    payload: result
});

export const debtActionsClear = () => ({
    type: DEBT_ACTIONS_CLEAR,
});

export const operatorActionCreated = action => ({
    type: OPERATOR_ACTION_CREATED,
    payload: action
});

export const callFinished = () => ({
    type: CALL_FINISHED,
    payload: null
});

export const phoneCreated = phone => ({
    type: OPERATOR_PHONE_CREATED,
    payload: phone
});

export const phoneUpdated = phone => ({
    type: OPERATOR_PHONE_UPDATED,
    payload: phone
});

export const emailCreated = email => ({
    type: OPERATOR_EMAIL_CREATED,
    payload: email
});

export const emailUpdated = email => ({
    type: OPERATOR_EMAIL_UPDATED,
    payload: email
});

export const debtorHygienized = data => ({
    type: OPERATOR_HYGIENIZED_DEBTOR,
    payload: data
});

export const dialTimerChanged = timer => ({
    type: OPERATOR_DIAL_TIMER_CHANGED,
    payload: timer
});

export const setVoipCampaign = campaign => ({
    type: SET_VOIP_CAMPAIGN,
    payload: campaign,
});

/**
 * Actions
 */
export const setContact = contact => dispatch =>
    dispatch(updateContact(contact));
export const setDialerCall = call => dispatch =>
    dispatch(updateDialerCall(call));

/**
 * Generate deal
 * @param {object} params
 */
export const createDeal = params => dispatch => {
    dispatch(dealCreateLoading(true));
    return createDealRequest(params)
        .then(({ data }) => {
            if (data.accept !== undefined && data.accept === true) {
                dispatch(dealCreated(data));
            }
            return data;
        })
        .finally(() => dispatch(dealCreateLoading(false)));
};

export const loadDebtActions = (pkDebt, type, page = 1) => async dispatch => {
    dispatch(debtActionsLoading(true));

    let operatorActions;
    let systemActions;
    const result = {};
    if (type === "operator") {
        operatorActions = await fetchOperatorActions(pkDebt, page);
        result.operator = operatorActions.data;
    } else if (type === "system") {
        systemActions = await fetchActions(pkDebt, page);
        result.system = systemActions.data;
    }

    dispatch(debtActionsLoaded(result));
    dispatch(debtActionsLoading(false));
};

export const createOperatorAction = params => async dispatch =>
    createOperatorActionRequest(params).then(res =>
        dispatch(operatorActionCreated(res.data))
    );

export const finishCall = () => dispatch => {
    dispatch(callFinished());
};

export const activateDebt = pkDebt => dispatch => operatorActivate(pkDebt);
export const finishDebt = pkDebt => dispatch => finish(pkDebt);
export const inactiveDebt = pkDebt => dispatch => inactive(pkDebt);

export const renewToken = data => dispatch =>
    dispatch({ type: AUTH_SET_TOKEN, payload: data });

export const loadDebtors = params => dispatch => {
    dispatch({ type: OPERATOR_LOAD_DEBTORS_REQUEST, payload: null });

    return operatorList(params)
        .then(res =>
            dispatch({ type: OPERATOR_LOAD_DEBTORS_SUCCESS, payload: res.data })
        )
        .catch(e => {
            dispatch({ type: OPERATOR_LOAD_DEBTORS_ERROR, payload: e });
            throw e;
        });
};

export const getOperatorDebtSimulation = (pkDebt, dueDate) => dispatch => {
    dispatch({ type: OPERATOR_LOAD_DEBT_SIMULATION_REQUEST, payload: null });
    return getOperatorDebtSimulationRequest(pkDebt, dueDate)
        .then(res => {
            dispatch({
                type: OPERATOR_LOAD_DEBT_SIMULATION_SUCCESS,
                payload: res.data
            });
            return res.data;
        })
        .catch(e => {
            dispatch({ type: OPERATOR_LOAD_DEBT_SIMULATION_ERROR, payload: e });
            throw e;
        });
};

export const getOperators = () => dispatch => {
    dispatch({ type: OPERATORS_LOAD_REQUEST, payload: null });
    return getOperatorsRequest()
        .then(res => {
            dispatch({ type: OPERATORS_LOAD_SUCCESS, payload: res.data });
            return res.data;
        })
        .catch(e => {
            dispatch({ type: OPERATORS_LOAD_ERROR, payload: e });
            throw e;
        });
};

export const loadRequests = params => dispatch => {
    dispatch({ type: LOAD_REQUESTS_REQUEST, payload: null });

    return list(params)
        .then(res =>
            dispatch({ type: LOAD_REQUESTS_SUCCESS, payload: res.data })
        )
        .catch(e => {
            dispatch({ type: LOAD_REQUESTS_ERROR, payload: e });
            throw e;
        });
};

export const findRequest = pkRequest => dispatch => {
    dispatch({ type: LOAD_REQUEST_REQUEST, payload: null });
    return loadRequest(pkRequest)
        .then(res =>
            dispatch({
                type: LOAD_REQUEST_SUCCESS,
                payload: res.data
            })
        )
        .catch(e => {
            dispatch({ type: LOAD_REQUEST_ERROR, payload: e });
            throw e;
        });
};

export const createPhone = (pkDebtor, params) => dispatch =>
    createPhoneRequest(pkDebtor, params).then(res =>
        dispatch(phoneCreated(res.data))
    );

export const updatePhone = (pkDebtor, pkPhone, params) => dispatch =>
    updatePhoneRequest(pkDebtor, pkPhone, params).then(res =>
        dispatch(phoneUpdated(res.data))
    );

export const createEmail = (pkDebtor, params) => dispatch =>
    createEmailRequest(pkDebtor, params).then(res =>
        dispatch(emailCreated(res.data))
    );

export const updateEmail = (pkDebtor, pkEmail, params) => dispatch =>
    updateEmailRequest(pkDebtor, pkEmail, params).then(res =>
        dispatch(emailUpdated(res.data))
    );

export const hygienizeDebtor = pkDebtor => dispatch =>
    hygienizeDebtorRequest(pkDebtor).then(res =>
        dispatch(debtorHygienized(res.data))
    );

export const setDialTimer = timer => dispatch =>
    dispatch(dialTimerChanged(timer));

// send button in requesr-info
export const sendInteraction = (id, text) => dispatch => {
    dispatch({ type: SEND_TEXT_REQUEST, payload: null });

    return sendText(id, text)
        .then(res => dispatch({ type: SEND_TEXT_SUCCESS, payload: res.data }))
        .catch(e => {
            dispatch({ type: SEND_TEXT_ERROR, payload: e });
            throw e;
        });
};

// send button in requesr-info
export const finishRequest = (id) => dispatch => {
    dispatch({ type: SEND_TEXT_REQUEST, payload: null });

    return sendFinishRequest(id)
        .then(res => dispatch({ type: SEND_TEXT_SUCCESS, payload: res.data }))
        .catch(e => {
            dispatch({ type: SEND_TEXT_ERROR, payload: e });
            throw e;
        });
};

export const sendFiles = (id, files) => dispatch => {
    dispatch({ type: SEND_TEXT_REQUEST, payload: null });

    return upload(id, files)
        .then(res => true)
        .catch(e => {
            throw e;
        });
};
